<template>
  <div class="table">
    <a-table
      :columns="columns"
      :dataSource="dataList"
      :pagination="pagination"
      @change="pagChange"
      @expandRowByClick="true"
      :rowKey="record => record.id"
      :loading="loading">
      <template slot="type" slot-scope="record">
        <span>{{ '报告/'+record.category.name}}</span>
          <div v-if="record.preLabels">
            <a-tag v-for="item in record.preLabels" :key="item.code">{{item.name}}</a-tag>
          </div>
      </template>
      <template slot="dept" slot-scope="record" v-if="record.dept">        
        <span v-if="record.dept">{{record.dept.name}}</span>
      </template>
      <template slot="date" slot-scope="record">
        <p>{{record.createTime | dateDiff}}</p>
        <p></p>
      </template>
      <template slot="operation" slot-scope="record">
        <a-button type="link" @click="showDrawer(record.id)" style="padding:0;">详情</a-button>
        <!-- <router-link :to="{ 
          path: '/product/manage/detail',
          name:'manage-detail', 
          query:{id:record.id,breadNum:3}}"
        >详情</router-link> -->
        <a-divider type="vertical" />
        <a-dropdown :trigger="['click']">
          <a class="ant-dropdown-link btnTag" color="#2db7f5">更多</a>
          <a-menu slot="overlay">
            <a-menu-item key="0">
              <!-- parentCode != '5' 为认证报告 只有新建 不可编辑删除 -->
              <a-button type="link" v-if="record.category.parentCode != '5'">
              <!-- <a-button type="link" v-if="record.category.parentCode != '5'"> -->
                <router-link :to="{ 
                  path: '/product/report/detail',
                  name:'report-detail', 
                  query:{id:record.id,breadNum:3}}"
                >编辑</router-link>
              </a-button>
              <a-button v-else type="link" disabled>编辑</a-button>
              
            </a-menu-item>
            <a-menu-item key="1">
              <a-button v-if="record.category.parentCode != '5'" @click="deleteReport(record.id)" type="link">删除</a-button>
              <a-button v-else type="link" disabled>删除</a-button>
            </a-menu-item>
          </a-menu>
        </a-dropdown>
      </template>
    </a-table>
    
      <a-drawer
        :width="600"
        placement="right"
        :closable="false"
        @close="closeDrawer"
        :wrapStyle="{'padding':'0'}"
        :visible="drawervisible">
        <template slot="title">
          <div class="detail-header">
            <div class="detail-header-left">
              <div class="user">
                <span class="user-title">报告详情</span>
                <span class="user-info">（{{detailObj.dept.name}}）</span>
              </div>
              <div class="company-title">
                <a-tag class="detail-tags" v-for="item in labelTitle" :key="item.code" >
                  {{item.name}}
                </a-tag>
              </div>
            </div>
            <div class="detail-header-right">
              <h2 class="detail-header-state">{{detailObj.state}}</h2>
              <h6 class="detail-header-others">{{`创建于${detailObj.createDate}` }}</h6>
            </div>
          </div>
        </template>
        <div class="detail-content" style="font-size:12px;">
          <div class="detail-message">
            <p>
              <span class="detail-message-key">报告编号：</span>
              <span class="detail-message-value">{{detailObj.number}}</span>
            </p>
            <p>
                <span class="detail-message-key">委托人名称：</span>
                <span class="detail-message-value"> {{detailObj.entrustName}}</span>
              </p>
              <p>
                <span class="detail-message-key">生产者（制造商）名称：</span>
                <span class="detail-message-value">{{detailObj.manufacturerName}}</span>
              </p>
              <p>
                <span class="detail-message-key">生产企业（生产厂家）名称：</span>
                <span class="detail-message-value">{{detailObj.factoryName}}</span>
              </p>
              <p>
                <span class="detail-message-key">产品名称：</span>
                <span class="detail-message-value">{{detailObj.product}}</span>
              </p>
              <p>
                <span class="detail-message-key">型号/规格：</span>
                <span class="detail-message-value">{{detailObj.modelSpecification}}</span>
              </p>
              <p>
                <span class="detail-message-key">产品标准和技术要求：</span>
                <span class="detail-message-value">{{detailObj.standard}}</span>
              </p>
              <p>
                <span class="detail-message-key">检测日期：</span>
                <span class="detail-message-value" v-if="detailObj.issueDate">{{detailObj.issueDate | formatDate}}</span>
              </p>
          </div>
          <div class="detail-adjunct">
            <h3>报告附件</h3>
            <div class="detail-adjunct-content">
              <template v-if="reportList.length>0">
                <div v-for="(item, index) in reportList" :key="index">
                  <template v-if="item.type == 'pic'"> 
                  <!-- 图片格式 -->
                  <a style="color:#a2a2a2">{{item.fileName}}</a>
                  <a @click="preview(item.inlineUrl)">预览</a>
                  <a :href="wordPreviewUrl(item.attachmentUrl)" :download="item.fileName">下载</a>
                </template>
                <template v-if="item.type == 'pdf'"> 
                  <!-- pdf格式 -->
                  <a style="color:#a2a2a2">{{item.fileName}}</a>
                  <a target="_blank" :href="wordPreviewUrl(item.inlineUrl)" >预览</a>
                  <!-- <span @click="downPDF(item.fileName,item.url)">下载</span> -->
                  <a :href="wordPreviewUrl(item.attachmentUrl)" :download="item.fileName">下载</a>
                </template>
                <template v-if="item.type == 'other'">
                  <a style="color:#a2a2a2">{{item.fileName}}</a>
                  <a @click="previewOther(item.url)">预览</a>
                  <a :href="wordPreviewUrl(item.attachmentUrl)" :download="item.fileName">下载</a>
                </template>
                </div>
              </template>
            </div>
          </div>
        </div>
      </a-drawer>
      <a-modal :visible="previewVisible" :maskClosable='false' :footer="null" @cancel='imagePreviewCancel'>
        <img alt="example" style="width: 100%" :src="previewImage" />
      </a-modal>
  </div>
</template>

<script>

import {formatDate,dateDiff} from '../../../utils/date';
import {getReprotListDetail} from '@/api/report'
import {getState} from '@/api/common'
import {getFileSuffix,isAssetTypeAnImage,isAssetTypeOther} from '@/utils/index' 
const align = 'center'

export default {
  props:{
    roleId:String
  },
  data() {
    return {
      previewImage:'',
      previewVisible:false,
      reportList:[],
      detailObj:{
        dept:{
          name:''
        },
        createDate:0,
        applicationNum:null,
      },
      drawervisible:false,
      columns:[
        {
          title: "序号",
          dataIndex: "No",
          align
        },
        // {
        //   title: "企业名称",
        //   scopedSlots: { customRender: 'dept' },
        //   align
        // },
        {
          title: "报告编号",
          dataIndex: "number",
          align
        },
        {
          title: "产品名称",
          dataIndex: "product",
          align
        },
        {
          title: "标签/报告类别",
          scopedSlots: { customRender: 'type' },
          align
        },
        {
          title: "创建时间",
          scopedSlots: { customRender: 'date' },
          align
        },
        {
          title: '操作',
          scopedSlots: { customRender: 'operation' },
          align,
          // fixed: 'right',
        }
      ],
      labelTitle:[],
      dataList:[],
      loading:false,
      pagination: {
        showSizeChanger:true,
        pageSizeOptions: ['10', '20', '30', '40', '50'],
        current: 1,
        pageSize: 10,
        total: 0,
        showTotal: total => `共 ${total} 条记录`,
        showSizeChange:(current, pageSize) => {
          this.pageSize = pageSize
        }
      },
    }
  },
  

  created () {
  },
  mounted () {
  },
  
  methods: {
    // 预览 word 和 PDF 时
    wordPreviewUrl(url) {
      if (url && url[0] === '/') {
        return window.location.origin + url;
      } else {
        return url;
      }
    },
    // 预览其他格式的
    previewOther(url){
      this.$message.warning('此功能还在开发中！请您下载查看！')
    },
    //下载pdf格式
    downPDF (fileName,data) {
      if (!data) {
        return;
      }
      let url = window.URL.createObjectURL(new Blob([data]));
      let link = document.createElement('a');
      link.style.display = 'none';
      link.href = url;
      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();
   },
    /**
     * 点击预览
     */
    preview(url){
      this.previewVisible = true;
      this.previewImage = this.wordPreviewUrl(url);
    },
    /**
     * 关闭图片预览
     */
    imagePreviewCancel(){
      this.previewVisible = false;
    },
    /**
     * 展示详情
     */
    showDrawer(id){
      this.drawervisible= true
      getReprotListDetail(id).then(res => {
        this.detailObj = res
        this.labelTitle = res.preLabels //标签
        this.detailObj.createDate = dateDiff(res.createTime)
        this.reportList = res.presentationAnnex //报告附件
        this.reportList.map(item => {
          if(item.fileName){
            item.type = getFileSuffix(item.fileName)
            if(isAssetTypeAnImage(item.type)){
              item.type = 'pic'
            }else if(isAssetTypeOther(item.type)){ //判断文件格式为其他格式
              item.type = 'other'
            }
          }
        })
      }).catch(error =>{
        console.log(error)
      })
    },
    /**
     * 关闭详情
     */
    closeDrawer(){
      this.drawervisible =false
      // this.detailObj={
      //   dept:{
      //     name:''
      //   },
      //   createDate:0,
      //   applicationNum:null,
      // }
    },
    /**
     * 删除当前报告
     */
    deleteReport(id){
      let that =this
      that.$confirm({
          title: '确定要删除吗',
          content: '删除后，信息将永久删除，请确认！',
          okText: '确认',
          cancelText: '取消',
          onOk:function () {
            that.$emit("deleteHandleOk",id)
          },
        })
    },
    /**
     * 翻页
     */
    pagChange(pagination,filters,sorter){
      this.pagination.current = pagination.current;
      this.pagination.pageSize = pagination.pageSize;
      this.$emit("pagChange")
    },
     
  },
  filters: {
    formatDate(time) {
      var date = new Date(time);
      return formatDate(date, "yyyy/MM/dd");
    },
    dateDiff(time){
      return dateDiff(time);
    }
  },
  watch: {
    roleId(val){
      if(val == 'admin' || val =='alphaliner'){   //  不是企业 不展示
        let newTitle = {
          title: "企业名称",
          scopedSlots: { customRender: 'dept' },
          align,
        }
        this.columns.splice(1,0,newTitle)
      }else{ // 是企业不展示
      this.columns.map((item,index)=>{
          if(item.title == '企业名称'){
            this.columns.splice(index,1)
          }
        })
      }
    },
  }
};
</script>

<style lang="less" scoped>
@detail-gray-color:#a2a2a2;
  /deep/.ant-dropdown-menu-item {
    padding: 0;
    .ant-btn {width:100%;height: 30px;text-align: center;}
  }
  .table {
    background-color: #fff; 
    /deep/.ant-table-expanded-row {
      td {
        padding: 5px 0 !important;
      }
      p {
        padding: 5px 0;
      }
    }

    .ant-alert-info {
      padding: 3px 15px 3px 37px;
      margin-bottom: 8px;
      display: flex;
      align-items: center;

      /deep/.ant-alert-icon {
        top: auto !important;
      }

      .info-slot {
        display: flex;
        align-items: center;

        .ant-btn {
          padding-right: 0px;
        }
      }
    }
    .btnTag{
      height: 32px;
      line-height: 32px;
      font-size: 14px;
      border-radius: 4px;
      margin-right:5px;
    }
  }
.detail-header{
    overflow: hidden;
    font-size: 14px;
    .detail-header-left{
      float: left;
      width:75%;
      .user{
        .user-title{
          font-weight: bold;
        }
        .user-info{
          color: @detail-gray-color;
        }
      }
      .detail-tags{
        margin-top: 8px;
        width: auto;
        height: auto;
        text-align: center;
        color: #333;
        padding: 2px 9px;
        margin-right: 12px;
        font-size: 12px;
        border:1px dashed #d9d9d9
      }
    }
    .detail-header-right{
      float: left;
      width:25%;
      .detail-header-state{
        font-weight:bold;
        font-size:16px;
        text-align:right;
        line-height:24px;
        padding-right: 22px;
      }
      .detail-header-others{
        font-size:12px;
        line-height:38px;
        color:@detail-gray-color;
        text-align: right;
      }
    }
  }
  .detail-content{
    font-size: 14px;
    .detail-message{
      padding-bottom: 20px;
      border-bottom: 1px solid #ccc;
      p{
        line-height: 28px;
        .detail-message-key{
          color: @detail-gray-color;
        }
      }
    }
    .detail-adjunct{
      border-bottom: 1px solid #ccc;
      h3{
        border-bottom: 1px solid #ccc;
        line-height: 20px;
        padding: 12px 0;
        font-weight: bold;
      }
      .detail-adjunct-content{
        padding: 12px;
        a{
          padding: 0 8px;
          line-height: 28px;
        }
        
      }
    }
    
  }
  /deep/.ant-table td { white-space: nowrap; }
  /deep/.ant-table th { white-space: nowrap; }
</style>
